import React from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import redPin from "../assets/images/red_pin.png";

const Map = props => {
    return (
        <GoogleMap
            defaultZoom={15}
            defaultCenter={{ lat: 43.7350295, lng: 18.5678010 }}
            options={{
                backgroundColor: "yellow",
                clickableIcons: false,
                disableDoubleClickZoom: true,
                fullscreenControl: false,
                scaleControl: false,
                zoomControl: false,
                scrollWheel: false,
                minZoom: 17,
                maxZoom: 17,
                gestureHandling: "none",
                draggable: false,
                disableDefaultUI: true
            }}>
            {props.isMarkerShown && <Marker position={{ lat: 43.7351295, lng: 18.5679510 }} icon={{ url: redPin }} />}
        </GoogleMap>
    );
};
export default withScriptjs(withGoogleMap(Map));
